/**
 * Site navigation – single source of truth for the header bar, the full-screen menu and the footer.
 * `NAV` is the six primary pages. `MENU_ITEMS` adds the front page and gives every row a one-line
 * descriptor and a preview photo for the menu overlay.
 */
export const NAV = [
  { to: "/rom", nn: "Rom", en: "Rooms", id: "rooms" },
  { to: "/mat", nn: "Mat", en: "Dining", id: "dining" },
  { to: "/opplev", nn: "Opplev", en: "Explore", id: "explore" },
  { to: "/arrangement", nn: "Selskap og møte", en: "Events & meetings", id: "events" },
  { to: "/praktisk", nn: "Praktisk", en: "Practical", id: "practical" },
  { to: "/om-oss", nn: "Om oss", en: "About", id: "about" },
];

const META = {
  home: { dnn: "Framsida", den: "Front page", img: "/images/hotel-aerial.jpg", pos: "50% 55%" },
  rooms: { dnn: "51 rom · frukost inkludert", den: "51 rooms · breakfast included", img: "/images/room-double.jpg", pos: "50% 50%" },
  dining: { dnn: "Restauranten og Strandkaféen", den: "The restaurant and Strandkaféen", img: "/images/restaurant-window.jpg", pos: "50% 55%" },
  explore: { dnn: "Basseng, Peparen og fjellet", den: "Pool, Peparen and the mountains", img: "/images/peparen-bridge.jpg", pos: "50% 60%" },
  events: { dnn: "Tre møterom og festsal for nitti", den: "Three meeting rooms and a hall for ninety", img: "/images/restaurant-hall.jpg", pos: "50% 55%" },
  practical: { dnn: "Vegen hit, innsjekk og spørsmål", den: "Getting here, check-in and FAQ", img: "/images/village-aerial.jpg", pos: "50% 55%" },
  about: { dnn: "Hotellet, folka og bygda", den: "The hotel, the people and the village", img: "/images/lounge.jpg", pos: "50% 50%" },
};

export const MENU_ITEMS = [{ to: "/", nn: "Heim", en: "Home", id: "home" }, ...NAV].map((n) => ({ ...n, ...META[n.id] }));
